// extracted by mini-css-extract-plugin
module.exports = {"logoGridContainer":"styles_logoGridContainer__B6LaM","logoWrapper":"styles_logoWrapper__58NWg","img":"styles_img__BS6PO"};